module.exports = __webpack_public_path__ + "static/media/User_1@3x.49be873f.png";